// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.short-info .badges__one-badge-cont {\n  width: 40px;\n  height: 40px;\n  margin-right: 2px;\n  margin-bottom: 15px;\n  margin-left: 2px;\n}\n.short-info .badges__badges-wrapper {\n  margin: 0 -2px;\n}\n.short-info .badges__one-badge-text {\n  display: none;\n}\n.short-info__comment-input .sk-input__textarea {\n  min-height: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
